import { useEffect, useState } from "react";
import { HTTP_METHODS, invokeApi } from "../../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../../utils/endpoints";
import CustomTable from "../../../../core/custom-table";
import { Box, Button, Tab, Tabs } from "@mui/material";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { RemoveRedEyeOutlined } from '@mui/icons-material';
import { TabContext, TabPanel } from "@mui/lab";
import TrainingApprovalFilters from "./training-approval-filters";
import CustomButtonComponent from "../../../../core/custom-button";


const TrainingApprovalAdmin = () => {
    const navigate = useNavigate();
    const [trainingDetailsList, setTrainingDetailsList] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    const [trainingRequestList, setTrainingRequestList] = useState([]);

    const pendingApprovalsListConfig = {
        HeaderConfig: [
            {
                label: "S l No.",
                id: "serialNumber"
            },
            {
                label: "Course Desired",
                id: "courseName",
            },
            {
                label: "Course Start Date",
                id: "courseStartDate",
            },
            {
                label: "Course End Date",
                id: "courseEndDate",
            },
            {
                label: "No. of the Candidates",
                id: "numberOfParticipants"
            },
            {
                label: "Venue",
                id: "venue"
            },
            {
                label: "Dealer Name",
                id: "dealerName"
            },
            {
                label: "View Details",
                id: 'viewDetails',
                render: (data) => {
                    return (
                        <span className='view-list-icon'>
                            <RemoveRedEyeOutlined onClick={() => viewParticipantList(data)} />
                        </span>
                    )
                }
            },
            {
                label: "Approval Status",
                id: "approvalStatus",
                render: (data) => {
                    return (
                        <span className={`approval-${data?.approvalStatus?.toLowerCase()}`}>
                            {data.approvalStatus}
                        </span>
                    )
                }
            },
            {
                label: "Status",
                id: "status",
                render: (data) => {
                    return (
                        <span className={`approval-${data?.status?.toLowerCase()}`}>
                            {data.status}
                        </span>
                    )
                }
            },
            {
                label: "Complete",
                id: "trainingStatus",
                render: (data) => {
                    return (
                        (data?.approvalStatus === 'ACCEPTED' && data?.status !== 'COMPLETED') ?
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => onClickComplete(data)}
                            >
                                Complete
                            </Button>
                            :
                            (data?.approvalStatus === 'ACCEPTED' && data?.status === 'COMPLETED') ?
                                <span className="completed-status">
                                    COMPLETED
                                </span>
                                :
                                <Button
                                    variant="contained"
                                    color="primary"
                                    disabled
                                >
                                    Complete
                                </Button>

                    )
                }
            }
        ]
    };

    useEffect(() => {
        getTrainingDetailsList();
        getRequestedTrainingList();
    }, []);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const onClickComplete = (trainingData) => {
        invokeApi(
            HTTP_METHODS.PUT,
            `${HOSTNAME}${REST_URLS.CREATE_TRAINING_SCHEDULE}/${trainingData.id}`,
            { status: 'COMPLETED' }
        ).then((response) => {
            toast.success('Training Completed Successfully');
            getTrainingDetailsList();
        });
    };

    const viewParticipantList = (data) => {
        navigate('/admin/training/training-requested-list', { state: { candidatesDetails: [{ ...data }] } })
    };

    const getRequestedTrainingList = () => {
        invokeApi(
            HTTP_METHODS.GET,
            `${HOSTNAME}${REST_URLS.GET_REQUESTED_COURSE_LIST}?status=PENDING`,
            null
        ).then((response) => {
            setTrainingRequestList(response?.map((listItem, index) => ({
                serialNumber: index + 1,
                courseStartDate: listItem?.courseDuration?.startDate?.split('T')[0],
                courseEndDate: listItem?.courseDuration?.endDate?.split('T')[0],
                model: listItem?.model,
                id: listItem?.id,
                status: listItem?.status,
                requestedBy: listItem?.requestedBy,
                ...listItem?.temp
            }))
            );
        });
    };

    const downloadReport = () => {
        invokeApi(
            HTTP_METHODS.GET,
            `${HOSTNAME}${REST_URLS.CREATE_TRAINING_SCHEDULE}`,
            null,
            { download: true },
            "blob"
        ).then((res) => {
            if (!res.message) {
                const url = window.URL.createObjectURL(res);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Training Schedule.xlsx");
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        }).catch((err) => console.error(err));
    };

    const getTrainingDetailsList = (filters = {}) => {
        setTrainingDetailsList([])
        invokeApi(
            HTTP_METHODS.GET,
            `${HOSTNAME}${REST_URLS.CREATE_TRAINING_SCHEDULE}`,
            null,
            filters
        ).then((response) => {
            setTrainingDetailsList(response?.map((listItem, index) => ({
                serialNumber: index + 1,
                courseStartDate: listItem?.course?.courseDuration?.startDate?.split('T')[0],
                courseEndDate: listItem?.course?.courseDuration?.endDate?.split('T')[0],
                ...listItem
            })));
        });
    };

    return (
        <>
            <div className="training-approval-list-container">
                <div className="title-container">
                    <div className="create-con">
                        <Box>
                            <span className="training-title">Training</span>
                            <div className="list-title">Training Completion Status</div>
                        </Box>
                        <Box sx={{ display: "flex", marginRight: "40px", marginTop: "10px" }}>
                            <CustomButtonComponent
                                variant="contained"
                                color="success"
                                onClick={downloadReport}
                            >
                                Download
                            </CustomButtonComponent>
                        </Box>
                    </div>
                </div>
                <div className="list-container">
                    <TrainingApprovalFilters loadData={getTrainingDetailsList} />
                    <Box sx={{ width: "100%" }}>
                        <TabContext value={String(activeTab)}>
                            <Box>
                                <Tabs
                                    value={activeTab}
                                    onChange={handleTabChange}
                                    scrollButtons
                                    variant="scrollable"
                                    allowScrollButtonsMobile
                                >
                                    <Tab label={`Training Request  (${trainingDetailsList.length})`} value={0} />
                                    <Tab label={`Special Request (${trainingRequestList.length})`} value={1} />
                                </Tabs>
                            </Box>

                            <TabPanel value="0" >
                                <CustomTable
                                    header={pendingApprovalsListConfig.HeaderConfig.filter((data) => !['status'].includes(data.id))}
                                    data={trainingDetailsList || []}
                                />
                            </TabPanel>
                            <TabPanel value="1">
                                <CustomTable
                                    header={pendingApprovalsListConfig.HeaderConfig.filter((data) => !['trainingStatus', 'approvalStatus'].includes(data.id))}
                                    data={trainingRequestList || []}

                                />
                            </TabPanel>
                        </TabContext>

                    </Box>
                </div>


            </div>
        </>
    )
};

export default TrainingApprovalAdmin; 